import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

interface EntityListItemProps {
  callbacks: {
    toggleEntity: () => void,
  },
  entityName: string,
  isChecked: boolean,
  disabled: boolean,
}

const EntityListItem = (props: EntityListItemProps) => {
  const {
    callbacks: { toggleEntity }, entityName, isChecked, disabled,
  } = props

  const onClick = disabled ? undefined : () => toggleEntity()

  return (
    // @ts-expect-error TS2339
    <ListItem.WithCheckbox
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        borderColor: 'lineColor',
        paddingY: 'small',
      }}
      checkbox={(
        <Checkbox
          checked={isChecked}
          onClick={onClick}
        />
      )}
      onClick={onClick}
    >
      <Box
        alignItems={['flex-start', 'center']}
        flexDirection={['column', 'row']}
        lineHeight="1.3"
        marginRight="auto"
        width="auto"
      >
        <Text fontSize="small">{entityName}</Text>
      </Box>
      {/*
     // @ts-expect-error TS2339 */}
    </ListItem.WithCheckbox>
  )
}

export default EntityListItem
